module.exports = {
    "crude": {
        "search": "шукати",
        "actions": "Дії",
        "nextPage": "Наступна сторінка",
        "lastPage": "Попередня сторінка",
        "back": "Назад",
        "empty": "порожній",
        "edit": "редагувати",
        "create": "створити",
        "data": "запис",
        "view": "шоу",
        "delete": "Видалити",
        "save": "зберегти",
        "cancel": "Скасувати",
        "noContent": "Немає записів. ",
        "resetFilter": "Скиньте фільтри та перегляньте більше вмісту!",
        "createOwnTextField": "Створіть власне текстове поле",
        "textFieldName": "мітка текстового поля",
        "textFieldValue": "Зміст",
        "insertTextFieldLabel": "Введіть назву текстового поля!",
        "deleteTextField": "Видалити текстове поле",
        "success": "Зберегти вдалося",
        "invalidDataFields": "Наступні поля даних недійсні:  ",
        "entries": "записи",
        "entry": "запис",
        "tabDetail": "деталі",
        "entity": "сутність",
        "of": "від",
        "uploadNewFile": "Завантажити файл",
        "upload": "завантажити",
        "confirm": "в порядку",
        "deleteFileQuestion": "Ви справді хочете видалити цей файл? ",
        "deleteFileQuestionTitle": "Небезпека!",
        "deleteEntityQuestion": "Ви справді хочете видалити цю сутність? ",
        "deleteEntityQuestionTitle": "Небезпека!",
        "errorLargeFileUpload": "Вибраний файл завеликий!",
        "useCroppedImage": "Використовуйте кадрування",
        "useOriginalImage": "Використовуйте оригінальне зображення",
        "available": "доступний",
        "searchColumn": "знайти стовпець",
        "manageColumns": "Керування стовпцями",
        "hideColumn": "приховати стовпець",
        "pinToRight": "Закріпити стовпець праворуч",
        "pinToLeft": "Закріпити стовпець ліворуч",
        "sortAsc": "Сортувати за зростанням",
        "sortDesc": "Сортувати за спаданням",
        "hideAll": "сховати все",
        "showAll": "Покажи все",
        "preview": "попередній перегляд",
        "title": "назва",
        "description": "опис",
        "tooltip": "підказка",
        "sort": "сортувати за",
        "settings": "Налаштування",
        "incomingReference": "посилання",
        "language": "Мова",
        "deleteTabQuestionTitle": "Небезпека!",
        "deleteTabQuestion": "Ви справді хочете видалити цю вкладку? ",
        "deleteElementQuestionTitle": "Небезпека!",
        "deleteElementQuestion": "Ви справді хочете видалити цей елемент? ",
        "configurationEditorDescriptionStringLayout": "У цій графі можна вибрати три варіанти введення тексту:",
        "configurationEditorDescriptionEnumLayout": "Для вибору елементів у цій колонці можна вибрати два варіанти:",
        "configurationEditorDescriptionBooleanLayout": "Для вибору елементів у цій колонці можна вибрати два варіанти:",
        "configurationEditorDescriptionForeignEntityLayout": "Для вибору елементів у цій колонці можна вибрати два варіанти:",
        "stringLayoutsingleline": "одна лінія",
        "stringLayoutmultiline": "багаторядковий",
        "stringLayouteditor": "Текстовий редактор",
        "enumLayoutradio": "радіо-кнопка",
        "enumLayoutdropdown": "розкривний список",
        "booleanLayoutcheckbox": "прапорець",
        "booleanLayoutswitch": "перемикачі",
        "foreignEntityLayoutpopUp": "вискочити",
        "foreignEntityLayoutautocomplete": "розкривний список",
        "foreignEntityLayoutlist": "список",
        "formatTooltipbold": "Жир",
        "formatTooltipitalic": "курсив",
        "formatTooltipunderline": "підкреслено",
        "formatTooltipstrike": "Викреслений",
        "formatTooltipclean": "чітке форматування",
        "formatTooltipcodeBlock": "код",
        "formatTooltipblockquote": "Цитата",
        "formatTooltipcolor": "колір шрифту",
        "formatTooltipbackground": "Колір фону",
        "formatTooltipfont": "шрифт",
        "formatTooltipalign": "вирівнювання",
        "formatTooltipheader": "розмір шрифту",
        "formatTooltipsuper": "Верхній індекс",
        "formatTooltipsub": "нижній індекс",
        "formatTooltipordered": "Упорядкований список",
        "formatTooltipbullet": "Перерахування",
        "true": "Так",
        "false": "немає",
        "selectEntity": "вибрати сутність",
        "filter": "фільтр",
        "useFilter": "Застосувати фільтри",
        "defaultFilter": "скинути фільтр",
        "expand": "розширити",
        "hide": "приховати",
        "minimumSelectionError": "Необхідно вибрати принаймні {{min}} записів.",
        "maximumSelectionError": "Можна вибрати максимум {{max}} записів."
    }
}
;